module.exports = __webpack_public_path__ + "img/dekstop-screen-active.417b0b6f.svg";